import React, { useEffect, useState } from "react";
import "../../commoncss/Common.css";
import Cookies from "universal-cookie";
import * as XLSX from "xlsx";
import { useToast } from "../../commoncomponents/ToastProvider";
import Loader from "../../commoncomponents/Loader";

const Adminupload = () => {
  const [getCsvFile, setCsvFile] = useState([{}]);
  const [getAgentList, setAgentList] = useState([{}]);
  const [getUploadagent, setUploadagent] = useState("");
  const [getUploadCount, setUploadCount] = useState([]);
  const [getUploadNumber, setUploadNumber] = useState(0);
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const cookie = new Cookies();

  const search_agent = async () => {
    try {
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/agent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({ token: cookie.get("admin") }),
      });
      const dataset = await resp.json();
      console.log(dataset);
      if (resp.status === 200) {
        if (dataset.status === true) {
          setAgentList(dataset.data.data);
        } else {
          showToast("Failed to fetch search results", "error");
        }
      } else {
        showToast("Request failed, try again", "error");
      }
    } catch (error) {
      console.log("Error fetching search results for upload", error);
      showToast(
        "Network error occured while fetching search results for upload, please try again later",
        "error"
      );
    }
  };

  const handlecsvRender = async (file) => {
    const d = new Date();
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      /* Update state */
      let arr = [];
      for (let i = 1; i < data.length; i++) {
        console.log(data, "datahere");
        try {
          var temp = {
            name: data[i][0],
            phone: data[i][1],
          };
          console.log(temp);
          arr.push(temp);
        } catch (error) {
          console.log(error, i, data[i]);
          continue;
        }
      }
      setCsvFile(arr);
      console.log(getCsvFile);
    };
    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  };

  const upload = async (username, phone) => {
    try {
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/upload`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: cookie.get("admin"),
          name: username,
          amount: 0,
          remark: "NEW LEAD",
          phone: phone,
          agent_id: getUploadagent,
        }),
      });
      if (resp.status == 200) {
        const dataset = await resp.json();
        let arr1 = getUploadCount;
        console.log(arr1.length, "length", getCsvFile.length);
        arr1.push(dataset);
        setUploadCount(arr1);
        setUploadNumber(arr1.length);

        // Show completion message when all uploads are done
        if (arr1.length === getCsvFile.length) {
          const successCount = arr1.filter(item => item.status === true).length;
          const failCount = arr1.length - successCount;
          if (failCount > 0) {
            showToast(`Upload completed: ${successCount} successful, ${failCount} failed`, "warning");
          } else {
            showToast(`All ${successCount} entries uploaded successfully`, "success");
          }
        }
      } else {
        showToast("Upload request failed for an entry", "error");
      }
    } catch (error) {
      console.log(error);
      showToast("Network error during upload", "error");
    }
  };

  const start_upload = async () => {
    // Validate agent is selected
    if (!getUploadagent || getUploadagent === "Select Agent") {
      showToast("Please select an agent", "error");
      return;
    }

    // Validate file is selected
    if (!getCsvFile || getCsvFile.length === 0) {
      showToast("Please select a file to upload", "error");
      return;
    }

    // Check if file has valid data
    const hasValidData = getCsvFile.some(item => item.name && item.phone);
    if (!hasValidData) {
      showToast("The selected file doesn't contain valid data. Please ensure it has Name and Phone columns.", "error");
      return;
    }

    setLoading(true);
    try {
      setUploadNumber(0);
      setUploadCount([]);
      console.log(getUploadCount.length, getUploadNumber, "active");
      for (let i = 0; i < getCsvFile.length; i++) {
        upload(getCsvFile[i].name, getCsvFile[i].phone);
      }
      showToast(`Uploading ${getCsvFile.length} entries...`, "info");
    } catch (error) {
      console.log(error);
      showToast("Error occurred during upload", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    search_agent();
  }, []);

  return (
    <div className="agent_wrapper">
      <div className="top_search_fields">
        <div className="fields_row">
          <div className="fields_item">
            <label>Select File</label>
            <input
              type="file"
              onChange={(e) => {
                handlecsvRender(e.target.files[0]);
              }}
            />
          </div>
          <div className="fields_item">
            <label>Agent</label>
            <select
              onChange={(e) => {
                setUploadagent(e.target.value);
              }}
            >
              <option>Select Agent</option>
              {getAgentList.map((e, index) => {
                return <option value={e.id}>{e.name}</option>;
              })}
            </select>
          </div>
        </div>
        <div className="btn_container" style={{ marginBottom: "20px" }}>
          <button
            onClick={(e) => {
              start_upload();
            }}
          >
            {loading ? <Loader loading={loading} /> : "Upload"}
          </button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <progress
            id="file"
            max={getCsvFile.length}
            value={getUploadCount.length}
          >
            hello
          </progress>
          <label style={{ marginLeft: "10px" }}>
            {getCsvFile.length > 0
              ? Math.round((getUploadCount.length / getCsvFile.length) * 100)
              : 0}
            %
          </label>
        </div>
      </div>
      {/* <div className="table_container">
        <table>
          <tr>
            <th>Total Amount</th>
            <th>Last Amount</th>
            <th>Last Remark</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Ticket</th>
            <th>Last Contacted By</th>
            <th>Updated Time</th>
            <th>Created Time</th>
            <th>Created By</th>
          </tr>
          {getData.map((e, index) => {
            if (Object.keys(e).length == 0) {
              return (<tr></tr>)
            } else {
              var dataset = e.data;
              const updatetimeorg = new Date(dataset[dataset.length - 1].updated_time)
              const createtimeorg = new Date(e.created_time)
              const updatetime = `${(updatetimeorg.getDate() > 9) ? updatetimeorg.getDate() : '0' + updatetimeorg.getDate()}/${(updatetimeorg.getMonth() > 8) ? updatetimeorg.getMonth() + 1 : '0' + (updatetimeorg.getMonth() + 1)}/${updatetimeorg.getFullYear()} ${updatetimeorg.getHours() > 9 ? updatetimeorg.getHours() : '0' + updatetimeorg.getHours()}:${updatetimeorg.getMinutes() > 9 ? updatetimeorg.getMinutes() : '0' + updatetimeorg.getMinutes()}:${updatetimeorg.getSeconds() > 9 ? updatetimeorg.getSeconds() : '0' + updatetimeorg.getSeconds()}`
              const createtime = `${(createtimeorg.getDate() > 9) ? createtimeorg.getDate() : '0' + createtimeorg.getDate()}/${(createtimeorg.getMonth() > 8) ? createtimeorg.getMonth() + 1 : '0' + (createtimeorg.getMonth() + 1)}/${createtimeorg.getFullYear()} ${createtimeorg.getHours() > 9 ? createtimeorg.getHours() : '0' + createtimeorg.getHours()}:${createtimeorg.getMinutes() > 9 ? createtimeorg.getMinutes() : '0' + createtimeorg.getMinutes()}:${createtimeorg.getSeconds() > 9 ? createtimeorg.getSeconds() : '0' + createtimeorg.getSeconds()}`
              return (
                <tr>
                  <td>₹{(e.amount / 100).toLocaleString("en-IN")}</td>
                  <td>₹{((dataset[dataset.length - 1].amount / 100).toLocaleString("en-IN") == "NaN" ? "0" : (dataset[dataset.length - 1].amount / 100).toLocaleString("en-IN"))}</td>
                  <td>{dataset[dataset.length - 1].remark}</td>
                  <td>{e.name}</td>
                  <td>{e.phone}</td>
                  <td>{e.ticket}</td>
                  <td>
                    {dataset[dataset.length - 1].entry_name}
                  </td>
                  <td>{updatetime}</td>
                  <td>{createtime}</td>
                  <td>
                    {dataset[0].entry_name}
                  </td>
                </tr>
              );
            }

          })}
        </table>
      </div> */}
      {/* <div className="table_container">
        <table>
          <tr>
            <th>Amount</th>
            <th>Remark</th>
            <th>Contacted By</th>
            <th>Updated Time</th>
          </tr>
          {getTrail.map((e, index) => {
            if (Object.keys(e).length == 0) {
              return (<tr></tr>)
            } else {
              const updatetimeorg = new Date(e.updated_time)
              const updatetime = `${(updatetimeorg.getDate() > 9) ? updatetimeorg.getDate() : '0' + updatetimeorg.getDate()}/${(updatetimeorg.getMonth() > 8) ? updatetimeorg.getMonth() + 1 : '0' + (updatetimeorg.getMonth() + 1)}/${updatetimeorg.getFullYear()} ${updatetimeorg.getHours() > 9 ? updatetimeorg.getHours() : '0' + updatetimeorg.getHours()}:${updatetimeorg.getMinutes() > 9 ? updatetimeorg.getMinutes() : '0' + updatetimeorg.getMinutes()}:${updatetimeorg.getSeconds() > 9 ? updatetimeorg.getSeconds() : '0' + updatetimeorg.getSeconds()}`
              return (
                <tr>
                  <td>₹{(e.amount / 100).toLocaleString("en-IN")}</td>
                  <td>{e.remark}</td>
                  <td>{e.entry_name}</td>
                  <td>{updatetime}</td>
                </tr>
              )
            }

          })}
        </table>
      </div> */}

      <br />
    </div>
  );
};

export default Adminupload;
